interface Props {
    m: number;
    t: number;
    d: number;
    isDesktop: boolean;
    isTable: boolean;
}

export const getSizeForLayout = ({m, d, t, isDesktop, isTable}: Props) => {
    if (isDesktop) return d;

    if (isTable) return t;

    return m;
}